/***************************************************************************
 * ========================================================================
 * Copyright (c) 2026 Broadcom Inc. and/or its subsidiaries. All Rights Reserved. Broadcom Confidential.
 * ========================================================================
 */

const moduleName = 'diagram';
const componentName = 'avi-area-graph';
const prefix = `${moduleName}.${componentName}`;

export const anomaliesLabel = `${prefix}.anomaliesLabel`;
export const configEventsLabel = `${prefix}.configEventsLabel`;
export const showMetricsLabel = `${prefix}.showMetricsLabel`;
export const systemEventsLabel = `${prefix}.systemEventsLabel`;
export const zoomInLabel = `${prefix}.zoomInLabel`;
export const zoomOutLabel = `${prefix}.zoomOutLabel`;
export const emptyDataLabel = `${prefix}.emptyDataLabel`;

export const ENGLISH = {
    [anomaliesLabel]: 'Anomalies',
    [configEventsLabel]: 'Config Events',
    [showMetricsLabel]: 'Show Metrics',
    [systemEventsLabel]: 'System Events',
    [zoomInLabel]: 'Zoom In',
    [zoomOutLabel]: 'Zoom Out',
    [emptyDataLabel]: 'No Data',
};
